import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDropDownRHFWithLabel,
	RHookFormDatePicker,
} from "@websential/cosmic-v20";

import { Grid } from "@mui/material";
import React from "react";

interface IStubReportHeader {
	employeeDDLItems?: any;
	setStateRunGetListAPICall: (value: boolean) => void
	// onApplyButtonClickedHandler: () => void;
}

export const StubReportHeader: React.FC<
	IStubReportHeader
> = ({ employeeDDLItems, setStateRunGetListAPICall }) => {
	return (
		<Grid
			container
			size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
			sx={{
				background: "#fff",
				border: "1px solid #e5e7eb",

				borderRadius: "2px",
				padding: "15px",
			}}
			columnSpacing={{ xs: 2, sm: 2, md: 3, lg: 2, xl: 2}}
		>
			<Grid size={{ xs: 12, sm: 4, md: 3.5, lg: 3, xl: 3 }}
				sx={{
					"& .MuiGrid-root .MuiFormLabel-root": { marginTop: "2px!important", },
				}}
			>
				<EnhancedDropDownRHFWithLabel
					selectName={"employee"}
					items={employeeDDLItems ?? []}
					selectedItem={"all"}
					label={"Employee"}
					testId={"employee-ddl"}
					onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
				/>

			</Grid>
			
			<Grid
				size={{ xs: 12, sm: 12, md: 3.5, lg: 3, xl: 3 }}
				sx={{
					"& .calenderWrapper ": { minWidth: "auto!important"}
				}}
			>
				<RHookFormDatePicker
					name="startDate"
					testId="start-date"
					label="Date Range"
					// labelPosition={LabelPosition.Top}
					format="M dd, yy"
					onDateSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
				/>
			</Grid>
			<Grid
				size={{ xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}
				sx={{ textAlign: "center", paddingTop: "30px" }}
			>
				<span style={{
					fontSize: "0.875rem",
					fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
					fontWeight: 500,
					letterSpacing: "0.00714em",
					color: "rgba(0, 0, 0, 0.6)",
					// paddingTop:"1.4rem"
				}}>to</span>
			</Grid>
			<Grid
				size={{ xs: 12, sm: 12, md: 3.5, lg: 3, xl:3 }}
				sx={{
					"& .MuiGrid-root .MuiFormLabel-root": { marginTop: "24px!important", },
					"& .calenderWrapper ": { minWidth: "auto!important"}
				}}
			>
				<RHookFormDatePicker
					name="endDate"
					testId="end-date"
					label=""
					// labelPosition={LabelPosition.Top}
					format="M dd, yy"
					onDateSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
				/>
			</Grid>
			
			<Grid
				size={{ xs: 12, sm: 12, md: 1.5, lg: 2.5, xl: 2.5}}
				sx={{
					marginTop: "27px!important",
				}}
			>
				<EnhancedButtonPrimeReact
					label="Apply"
					raised
					type="submit"
					// onClickHandler={onApplyButtonClickedHandler}
					severity={EnhancedButtonPrimeReactSeverity.Secondary}
				/>
			</Grid>

		</Grid>
	);
};
